/** Aviso breve tras una acción ("Guardado ✓") y barra de acciones fija sobre el menú inferior. */
let timer: ReturnType<typeof setTimeout> | null = null;

export function toast(message: string, kind: 'ok' | 'error' = 'ok') {
  let el = document.getElementById('toast');
  if (!el) { el = document.createElement('div'); el.id = 'toast'; el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
  el.textContent = message;
  el.classList.toggle('error', kind === 'error');
  el.classList.add('show');
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => el!.classList.remove('show'), kind === 'error' ? 4500 : 2200);
}

/** Muestra (o quita, con html vacío) la barra fija de acciones. Se quita sola al cambiar de pantalla. */
export function stickyBar(html: string) {
  let el = document.getElementById('sticky');
  if (!html) { el?.remove(); document.body.classList.remove('has-sticky'); return; }
  if (!el) { el = document.createElement('div'); el.id = 'sticky'; el.className = 'sticky-actions'; document.body.appendChild(el); }
  el.innerHTML = `<div class="bar-inner">${html}</div>`;
  document.body.classList.add('has-sticky');
  return el;
}

export function clearChrome() {
  stickyBar('');
  document.getElementById('fab')?.remove();
  document.body.classList.remove('has-fab');
}

export function fab(href: string, label: string) {
  if (document.getElementById('fab')) return;
  const a = document.createElement('a');
  a.id = 'fab'; a.className = 'fab'; a.href = href; a.setAttribute('aria-label', label); a.title = label; a.textContent = '+';
  document.body.appendChild(a);
  document.body.classList.add('has-fab');   // la página deja hueco al final para que el botón no tape lo último
}
